export const importVehiclesTypes = {
  SET_VEHICLES_DATA: "context/SET_VEHICLES_DATA",
  SET_VEHICLES_PROCESSING: "context/SET_VEHICLES_PROCESSING",
  RESET_VEHICLES: "context/RESET_VEHICLES",
  SET_SELECTED_PRODUCTS: "context/SET_SELECTED_PRODUCTS",
  SET_WHITELIST_CHANGES: "context/SET_WHITELIST_CHANGES",
};
